import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import type { AppRouter } from '../../../api/src/routers/index';
import { useAuthStore } from '@/store/authStore';
import superjson from 'superjson';

export const trpc = createTRPCReact<AppRouter>();

// Get base URL for API
export const getBaseUrl = () => {
  const api = import.meta.env.VITE_API_URL || 'http://localhost:4000';
  return `${api}/trpc`;
};

export const createTRPCClient = () => {
  return trpc.createClient({
    transformer: superjson,
    links: [
      httpBatchLink({
        url: getBaseUrl(),
        headers() {
          const { token } = useAuthStore.getState();
          return {
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json',
          };
        },
      }),
    ],
  });
};
